import { Injectable } from '@angular/core';

@Injectable()
export class TreeviewConfig {
    isShowAllCheckBox = true;
    isShowFilter = false;
    isShowCollapseExpand = false;
    maxHeight = 500;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/treeview-config.ts